
import GenericError from '../GenericError'

/**
 * Errors occurring due to malformed, invalid or unexpected user input.
 */
export default class InvalidInputError extends GenericError {
}
